import mixpanel from 'mixpanel-browser';
import { environments } from '@8fig/environments';
import { parse } from 'qs';

mixpanel.init('3752c9768b57100c9d0a24cf53e1b08f');

const env_check = process.env.REACT_APP_ENV === environments.prod;

const actions = {
  identify: (id: string) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id: string) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name: string, props?: Record<string, unknown>) => {
    if (env_check) {
      const urlParams = new URLSearchParams(window.location.search);
      mixpanel.track(name, {
        ...props,
        url_params: parse(urlParams?.toString()),
      });
    }
  },
  people: {
    set: (props: Record<string, unknown>) => {
      if (env_check) mixpanel.people.set(props);
    },
    append(list: string, value: string) {
      if (env_check) mixpanel.people.append(list, value);
    },
  },
};

export default actions;
